import React, { useState } from 'react';
import {
  Typography,
  Box,
  Tabs,
  Stack,
  Tab
} from '@mui/material';
import { Icon } from '@iconify/react';
import TicketsList from '../dashboard/stats/TicketsList';
import SuggestionsStats from '../dashboard/stats/SuggestionsStats';

const tabs = [
  {
    id: 'tickets',
    name: 'Tickets',
    icon: <Icon icon="solar:document-broken" width="24" height="24" />
  },
  {
    id: 'suggestions',
    name: 'Suggestions',
    icon: <Icon icon="token:chat" width="24" height="24" />
  }
]

export default function CustomerTicketsList() {
  const [selectedTab, setSelectedTab] = useState(tabs[0].id);

  return (
    <Box sx={{ padding: 3 }}>

      <Box sx={{ mb: 3 }}>
        <Tabs
          value={selectedTab}
          onChange={(e, value) => setSelectedTab(value)}
          sx={{
            px: 2,
            borderRadius: 1,
            borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
          }}
        >
          {tabs.map((tab) => (
            <Tab
              key={tab.id}
              value={tab.id}
              label={
                <Stack direction="row" alignItems="center" spacing={1}>
                  {tab.icon}
                  <Typography variant="body2">{tab.name}</Typography>
                </Stack>
              }
            />
          ))}
        </Tabs>
      </Box>

      {selectedTab === 'tickets' && <TicketsList />}
      {selectedTab === 'suggestions' && <SuggestionsStats />}
    </Box>
  );
}
